export default __webpack_public_path__ + "static/media/basket_main.4ef51aa8.png";